/* ============================================================
   SCENED  /  Verhalten für alle SCENED Sections
   Läuft auch im Shopify Theme Editor (section:load).
   ============================================================ */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll Reveal ---------- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });

  /* ---------- Panel Reveal (Blur zu Fokus) ---------- */
  var panelObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('is-open');
    });
  }, { threshold: 0.3 });

  /* ---------- Timeline ---------- */
  var trackObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var track = entry.target;
      var fill = track.querySelector('.sc-track__fill');
      if (fill) {
        if (window.innerWidth <= 860) { fill.style.height = '100%'; }
        else { fill.style.width = '100%'; }
      }
      track.querySelectorAll('.sc-node').forEach(function (node, i) {
        setTimeout(function () { node.classList.add('is-on'); }, i * 600);
      });
      trackObserver.unobserve(track);
    });
  }, { threshold: 0.35 });

  /* ---------- Hero Unlock ---------- */
  var heroes = [];
  function heroFrame() {
    heroes.forEach(function (hero) {
      var media = hero.querySelector('.sc-hero__media');
      var shackle = hero.querySelector('.sc-hero__shackle');
      var state = hero.querySelector('.sc-hero__lockstate');
      var rect = hero.getBoundingClientRect();
      var progress = Math.min(Math.max((0 - rect.top) / 520, 0), 1);

      if (media && !reduce) {
        media.style.filter = 'blur(' + ((1 - progress) * 24 + 2) + 'px) brightness(' + (0.42 + progress * 0.5) + ')';
        media.style.transform = 'scale(' + (1.14 - progress * 0.1) + ')';
      }
      if (shackle && !reduce) {
        shackle.style.transform = 'rotate(' + (-progress * 40) + 'deg) translateY(' + (-progress * 3) + 'px)';
      }
      if (state) {
        var open = progress > 0.7;
        state.textContent = open ? state.dataset.openLabel : state.dataset.lockedLabel;
        state.style.color = open ? 'var(--sc-acc)' : '#CCC';
      }
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (heroes.length === 0 || ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { heroFrame(); ticking = false; });
  }, { passive: true });

  /* ---------- Formular ---------- */
  function bindForm(form) {
    if (form.dataset.scBound) return;
    form.dataset.scBound = '1';
    form.addEventListener('submit', function (e) {
      // Echte Shopify Formulare haben ein action-Attribut und werden normal abgeschickt.
      if (form.getAttribute('action')) return;
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      var success = form.parentNode.querySelector('.sc-success');
      if (!input || input.value.indexOf('@') === -1) { if (input) input.focus(); return; }
      if (success) success.hidden = false;
      input.value = '';
    });
  }

  /* ---------- Initialisierung ---------- */
  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.sc-rv:not(.is-in)').forEach(function (el) { revealObserver.observe(el); });
    root.querySelectorAll('.sc-reveal__panel').forEach(function (el) { panelObserver.observe(el); });
    root.querySelectorAll('.sc-track').forEach(function (el) { trackObserver.observe(el); });
    root.querySelectorAll('.sc-hero').forEach(function (el) {
      if (heroes.indexOf(el) === -1) heroes.push(el);
    });
    root.querySelectorAll('.sc-form').forEach(bindForm);
    heroFrame();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme Editor: Sections neu laden */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
